const COURSE_ID = 1;
const UNIT_COUNT = 5;
const LESSONS_PER_UNIT = 10;
const UNIT_TITLES = [
    'Foundations of Literature',
    'Narrative Writing',
    'Poetry and Figurative Language',
    'Research and Argument',
    'Capstone Review',
];
const LESSON_TOPICS = [
    'Plot and Conflict',
    'Character Development',
    'Setting and Mood',
    'Theme and Central Idea',
    'Point of View',
    'Introduction to Narrative',
    'Drafting a Personal Essay',
    'Peer Review Workshop',
    'Revision Strategies',
    'Publishing and Reflection',
    'Metaphor and Simile',
    'Sound Devices in Poetry',
    'Analyzing a Poem',
    'Writing Free Verse',
    'Poetry Performance',
    'Choosing a Research Topic',
    'Evaluating Sources',
    'Outlining an Argument',
    'Writing a Claim',
    'Counterarguments',
    'Integrating Evidence',
    'Works Cited Basics',
    'Oral Presentation Skills',
    'Media Literacy',
    'Close Reading Practice',
    'Compare and Contrast Texts',
    'Summarizing Nonfiction',
    'Vocabulary in Context',
    'Grammar for Clarity',
    'Sentence Variety',
    'Paragraph Structure',
    'Transitions and Flow',
    'Editing for Conventions',
    'Timed Writing Practice',
    'Rubric Self-Assessment',
    'Collaborative Discussion',
    'Socratic Seminar Prep',
    'Analyzing Author Purpose',
    'Identifying Bias',
    'Visual Rhetoric',
    'Digital Research Skills',
    'Note-Taking Methods',
    'Paraphrasing and Quoting',
    'Avoiding Plagiarism',
    'Capstone Planning',
    'Capstone Draft Review',
    'Capstone Final Submission',
    'Course Reflection',
    'Portfolio Assembly',
    'End-of-Course Review',
];
const LESSON_ASSESSMENT_TYPES = [
    ['Discussion', 'Participation'],
    ['Portfolio Item'],
    ['Practice'],
    ['Quick Check'],
    ['Quiz'],
    ['Reflection'],
    ['Sample Work'],
    ['Skills Check'],
    ['Test'],
    ['Course Survey'],
    ['Draft'],
    ['End of Course Exam'],
    ['Final Exam'],
    ['Practice for AP Exam'],
    ['Pretest'],
    ['Teacher Graded Skills Check'],
];
const buildLesson = (id, idUnit, topic, assessmentTypes, duration) => ({
    id,
    treeNodeId: `lesson_${id}`,
    idCourse: COURSE_ID,
    idUnit,
    idLesson: id,
    assessmentTypes,
    duration,
    isPublic: id % 7 !== 0,
    name: topic,
    nodeType: 'lesson',
});
const buildUnits = () => {
    let nextLessonId = 100;
    return UNIT_TITLES.slice(0, UNIT_COUNT).map((unitTitle, unitIndex) => {
        const idUnit = unitIndex + 1;
        const lessons = Array.from({ length: LESSONS_PER_UNIT }, (_, lessonIndex) => {
            const topicIndex = unitIndex * LESSONS_PER_UNIT + lessonIndex;
            const lessonNumber = lessonIndex + 1;
            const assessmentIndex = unitIndex * LESSONS_PER_UNIT + lessonIndex;
            return buildLesson(nextLessonId + lessonIndex, idUnit, `Lesson ${lessonNumber}: ${LESSON_TOPICS[topicIndex]}`, LESSON_ASSESSMENT_TYPES[assessmentIndex % LESSON_ASSESSMENT_TYPES.length], assessmentIndex === 0 ? 4 : undefined);
        });
        nextLessonId += LESSONS_PER_UNIT;
        return {
            id: idUnit,
            treeNodeId: `unit_${idUnit}`,
            idCourse: COURSE_ID,
            idUnit,
            isPublic: true,
            name: `Unit ${idUnit}: ${unitTitle}`,
            nodeType: 'unit',
            children: lessons,
        };
    });
};
const courseOutlineMockRoot = {
    id: COURSE_ID,
    treeNodeId: `course_${COURSE_ID}`,
    idCourse: COURSE_ID,
    isPublic: true,
    name: 'ELA 25/26 English 9 A',
    nodeType: 'course',
    children: buildUnits(),
};
export default courseOutlineMockRoot;
